'use client';

import { useSearchParams } from 'next/navigation';

import { CartIconLink } from '@/app/donation/_components/CartIconLink';
import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { SearchedSection } from './_components/SearchedSection';
import { SearchPrepareSection } from './_components/SearchPrepareSection';
import { recentHistory } from './_utils/recent-history';

const GiftsSearchPage = () => {
  const { replace } = useCustomRouter();
  const searchParams = useSearchParams();
  const { add } = recentHistory;

  const searchKeyword = searchParams?.get('searchKeyword') ?? undefined;

  const handlePrepareKeywordClick = (
    keyword: string,
    category: '최근 검색어' | '추천 검색어',
  ) => {
    add(keyword);

    replace(
      DONATION_ROUTES.GIFTS_SEARCH.withSearchParams({
        searchParams: {
          searchKeyword: keyword,
          category,
        },
      }),
    );
  };

  return (
    <article className="flex flex-col">
      <PageNavigation
        isNotUsedHomeButton
        searchForm
        searchFormDefaultValue={searchKeyword}
        onSearchFormSubmit={(keyword) => {
          if (keyword) {
            add(keyword);
          }

          replace(
            DONATION_ROUTES.GIFTS_SEARCH.withSearchParams({
              searchParams: {
                searchKeyword: keyword ? keyword : undefined,
                category: keyword ? '일반 검색' : undefined,
              },
            }),
          );
        }}
        onSearchFormMount={(el) => {
          el.focus();
        }}
      >
        <CartIconLink className="ml-10 self-center" />
      </PageNavigation>

      <h1 className="sr-only">답례품 검색</h1>
      {searchKeyword ? (
        <SearchedSection
          searchKeyword={searchKeyword}
          onHistoryClick={handlePrepareKeywordClick}
          onRecommendClick={handlePrepareKeywordClick}
        />
      ) : (
        <SearchPrepareSection
          onHistoryClick={handlePrepareKeywordClick}
          onRecommendClick={handlePrepareKeywordClick}
          className="hidden mobile-tablet:flex"
        />
      )}
    </article>
  );
};

export default GiftsSearchPage;
